// extracted by mini-css-extract-plugin
export var externalLink = "_97-0";
export var internalLinkLabel = "_97-1";